export function checkImageUrlFromNotion(url?: string): boolean {
  const notionUrls = [
    'https://s3.us-west-2.amazonaws.com/secure.notion-static.com',
    'https://prod-files-secure.s3.us-west-2.amazonaws.com',
  ];

  return (url && notionUrls.some((text) => url.includes(text))) || false;
}
